import { defineComponent as _defineComponent } from 'vue'
import type { TranslateResult } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'g-t-view',
  props: {
    text: null,
    width: null
  },
  setup(__props: any) {

const props = __props as {
  text: TranslateResult
  width?: string
}



return { __sfc: true,props }
}

})